import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Refresh2(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeWidth: 2, d: "m14 15-4 4 4 4" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M18.062 8.5A7 7 0 0 1 12 19" }), _jsx("path", { stroke: "currentColor", strokeWidth: 2, d: "m10 9 4-4-4-4" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M5.938 15.5A7 7 0 0 1 12 5" })] }) });
}
const Refresh2 = forwardRef(_Refresh2);
export { Refresh2 };
